export const isLeadFormFieldHidden = (fieldData) => {
  if (!fieldData?.su_options) return false;

  const type = Number(fieldData.su_form_variable_type);

  try {
    const opt = JSON.parse(fieldData.su_options);
    if (type === 1) return opt?.["0"]?.hide === true;
    if ([3, 4, 12, 13].includes(type)) return opt?.hide === true;
    return false;
  } catch {
    return false;
  }
};
